// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"336":"033b0f3c319a7721","736":"5cef34f19c760201","818":"c6f62554d1ccca5a"}[chunkId] + ".js";
};